module.exports = __webpack_public_path__ + "static/media/k-star.a71226f7.svg";